import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Whether the logged-in user is a student and, if so, the licensed
 * sonographers they can pick as Supervising Sonographer on a worksheet
 * (GET /api/profile/supervisors — students and the user themselves are
 * already filtered out server-side).
 *
 * On any error this reports isStudent: false, so a network hiccup never
 * blocks a regular user's worksheet.
 */
export function useSupervisors() {
  const [isStudent, setIsStudent] = useState(false);
  const [supervisors, setSupervisors] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem('token');
    if (!token) return undefined;

    const apiUrl = process.env.REACT_APP_API_URL || '';
    axios.get(`${apiUrl}/api/profile/supervisors`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (cancelled || !res.data?.success) return;
        setIsStudent(!!res.data.isStudent);
        setSupervisors(res.data.supervisors || []);
      })
      .catch(err => {
        console.error('Error fetching supervisors:', err);
      });

    return () => { cancelled = true; };
  }, []);

  return { isStudent, supervisors };
}
